import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Spin,
  Switch,
  Typography,
  message,
} from "antd";
import { getFiserv, upsertFiserv } from "./api";
import { FiservConfig } from "./types";

const { Text } = Typography;

interface Props {
  sellerCode: string;
}

export const FiservCard: React.FC<Props> = ({ sellerCode }) => {
  const [form] = Form.useForm<FiservConfig>();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await getFiserv(sellerCode);
      form.setFieldsValue(data);
    } catch {
      message.error("No se pudo cargar Fiserv");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sellerCode) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerCode]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await upsertFiserv(sellerCode, values);
      message.success("Fiserv guardado");
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || "Error al guardar";
      message.error(Array.isArray(msg) ? msg.join(" • ") : msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      title="Fiserv (Decidir / FirstData)"
      extra={
        <Button type="primary" loading={saving} onClick={handleSave}>
          Guardar
        </Button>
      }
      style={{ marginBottom: 16 }}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label="Habilitado" name="enabled" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Modo producción" name="productionModeEnabled" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Título (opcional)" name="title">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item label="Descripción (opcional)" name="description">
            <Input />
          </Form.Item>

          <Divider orientation="left">
            <Text strong>Credenciales producción</Text>
          </Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Store name" name="productionStoreName">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Shared secret" name="productionSharedSecret">
                <Input.Password placeholder="••••••••" />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left">
            <Text strong>Credenciales integración / sandbox</Text>
          </Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Store name" name="integrationStoreName">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Shared secret" name="integrationSharedSecret">
                <Input.Password placeholder="••••••••" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Monto máximo sin verificación"
                name="maxAmountWithoutVerification"
              >
                <InputNumber min={0} style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Card>
  );
};
